export const styles = {
    loginscreen:{
        display:"flex",
        justifyContent:"center",
        alignItems:'center',
        maxHeight:"30vh",
        textAlign:"center",
        margin:"160px",
    },
    text:{
        width:"400px",
        height:"5rem",
        lineHeight: "1.6em",
        padding: 1,
    },
    btnLogin:{
        lineHeight: "2.55rem",
        letterSpacing:"1em",
        textAlign:"center",
        fontWeight:"bold",
        textDecoration:"none",
        color:"#fff",
        backgroundColor: "#291e38",
        marginTop:"15px"
    },
    btnText:{
        color:"#fff",
    },
    message: {
        width: 400, 
        height:100, 
        borderColor:"#909090", 
        borderWidth:1.3, 
        marginBottom:"10px"
    }
}